import {defineMessages} from 'react-intl';

export default defineMessages({
	success: {
		id: 'popups.newsletter.signIn.success',
		defaultMessage: 'You’re successfully subscribed to our Newsletter',
	},
	alreadySubscribed: {
		id: 'popups.newsletter.signIn.alreadySubscribed',
		defaultMessage: 'You already subscribed to the newsletter',
	},
	failure: {
		id: 'popups.newsletter.signIn.failure',
		defaultMessage: 'Unexpected error',
	},
	emailPlaceholder: {
		id: 'popups.newsletter.signIn.emailPlaceholder',
		defaultMessage: 'Email Address',
	},
	emailRequired: {
		id: 'popups.newsletter.signIn.emailError',
		defaultMessage: 'The email address field is mandatory',
	},
	emailError: {
		id: 'popups.newsletter.signIn.invalidEmail',
		defaultMessage: 'Email field is incorrect. Check again',
	},
	cta: {
		id: 'popups.newsletter.signIn.cta',
		defaultMessage: 'Subscribe',
	},
	genderError: {
		id: 'popups.newsletter.genderError',
		defaultMessage: 'Selected a gender',
	},
	privacyPolicyAndTOS: {
		id: 'popups.newsletter.privacyPolicyAndTOS',
		defaultMessage:
			'<p>This site is protected by reCAPTCHA and the Google <link1>Privacy Policy</link1> and ' +
			'<link2>Terms of Service</link2> apply.</p><p>Read the <link3>Privacy Policy</link3></p>',
	}
});
